import { useEffect, useRef, memo } from 'react';
import { getSizesByAdType } from '@/lib/ads';

// @refresh reset

function OneAOneAds() {
  const tag = useRef(`div-gpt-ad-1x1generico-${new Date().getTime() + Math.floor(Math.random() * 100)}`);

  useEffect(() => {
    const { googletag } = window;

    const sizeOneAOne = getSizesByAdType('1x1');

    googletag.cmd.push(() => {
      const REFRESH_KEY = 'refresh';
      const REFRESH_VALUE = 'true';
      googletag.pubads().enableAsyncRendering();
      const slotGt = googletag
        .defineSlot(`/22189562696/1x1`, sizeOneAOne, tag.current)
        .setTargeting(REFRESH_KEY, REFRESH_VALUE)
        .setTargeting('refreshed_slot', 'false')
        .addService(googletag.pubads());
      googletag.display(tag.current);
      googletag.pubads().refresh([slotGt]);
    });
  }, []);

  return <div id={tag.current} className="oneaone" data-ad="true" style={{ height: 1, width: 1, position: 'absolute', top: 0, left: 0 }} />;
}

const OneAOneAdGeneratorMemo = memo(OneAOneAds, () => true);

export default OneAOneAdGeneratorMemo;
